import { Component } from '@angular/core';

@Component({
  selector: 'app-eventos-genericos',
  templateUrl: './eventos-genericos.component.html',
  styleUrls: ['./eventos-genericos.component.scss'],
  standalone: false,
})
export class EventosGenericosComponent {
  public selectedTab = 0;

  public tabChanged(event: any) {
    this.selectedTab = event.index;
  }
}
